module.exports = "/_next/static/images/wallet-empty-neue-3a9b4c64c3d950988bf92d6f36326141.png";